import type {
  BoxProps,
  ComponentWithAs,
  IconProps,
  ThemeTypings,
} from "@chakra-ui/react"
import { Icon, Box, Spinner, Stack, HStack, Text } from "@chakra-ui/react"
import type { FC, ReactNode } from "react"

type SwapRecipeInfoProps = {
  colorScheme: ThemeTypings["colorSchemes"]
  title?: string
  body: ReactNode
  isLoading?: boolean
  leftIcon?: ComponentWithAs<"svg", IconProps>
}

const SwapRecipeInfo: FC<SwapRecipeInfoProps & BoxProps> = ({
  colorScheme,
  title,
  body,
  isLoading,
  leftIcon,
  ...boxProps
}) => {
  return (
    <HStack
      {...boxProps}
      bg={`${colorScheme}.50`}
      border="1px"
      borderColor={`${colorScheme}.300`}
      borderRadius="lg"
      p={3}
    >
      <Box w="3%">
        {isLoading && <Spinner color={colorScheme} size="sm" />}
        {leftIcon && <Icon as={leftIcon} color={`${colorScheme}.600`} />}
      </Box>
      <Stack color={`${colorScheme}.600`} fontSize="sm" spacing={0}>
        {title && <Text fontWeight="bold">{title}</Text>}
        {body}
      </Stack>
    </HStack>
  )
}

export default SwapRecipeInfo
